/* STATUS / AGENT NOTES (2026-10-22)
   Agent START Codex: Generated shared adapter modules. Run scripts/sync-wingmate-viewer-modules.mjs; do not hand-edit. */

// Shared source: public/case-simulator/engine/viewer-embed.js
// Only the current owned frame may report status or close its modal. Messages
// contain no scene data and target the embedding page's exact origin.
const productMessages=new Set(['close','ready','error']);
export function isWingmateProductMessage(event,frame,origin,state){
 return productMessages.has(state)&&!!frame&&event.source===frame.contentWindow&&event.origin===origin&&event.data?.type==='wingmate:'+state&&event.data?.version===1;
}
export function isWingmateCloseRequest(event,frame,origin){
 return isWingmateProductMessage(event,frame,origin,'close');
}
function productParentOrigin(profile,win,doc){
 if(profile.kind!=='product'||win.parent===win)return null;
 try{
  const supplied=new URLSearchParams(win.location.search).get('parentOrigin');
  const target=new URL(supplied??doc.referrer);
  if(!['http:','https:'].includes(target.protocol)||(supplied&&supplied!==target.origin))return null;
  return target.origin;
 }catch{return null}
}
export function notifyWingmateProductStatus(state,profile,win=window,doc=document){
 if(state!=='ready'&&state!=='error')throw new TypeError('Invalid product viewer status');
 const origin=productParentOrigin(profile,win,doc);if(!origin)return false;
 win.parent.postMessage({type:'wingmate:'+state,version:1},origin);return true;
}
export function bindWingmateProductEscape(profile,win=window,doc=document){
 const origin=productParentOrigin(profile,win,doc);if(!origin)return ()=>{};
 const keydown=event=>{if(event.key==='Escape'){event.preventDefault();win.parent.postMessage({type:'wingmate:close',version:1},origin)}};
 doc.addEventListener('keydown',keydown);
 return ()=>doc.removeEventListener('keydown',keydown);
}


// Shared source: public/case-simulator/integration/product-identity.js
// Exact reviewed storefront identity only. Gallery media aliases and SKUs do not
// establish physical fit, and this resolver never chooses a default variant.
const own = (object, key) => Object.prototype.hasOwnProperty.call(object, key);
const record = value => value !== null && typeof value === 'object' && !Array.isArray(value);
const slug = value => typeof value === 'string' && /^[a-z0-9]+(?:-[a-z0-9]+)*$/.test(value) && value.length <= 100;
const failure = reason => ({ eligible: false, reason });

function shopifyId(value, kind) {
  if (typeof value === 'number') return Number.isSafeInteger(value) && value > 0 ? String(value) : null;
  if (typeof value !== 'string') return null;
  if (/^[1-9][0-9]*$/.test(value)) return value;
  return value.match(new RegExp(`^gid://shopify/${kind}/([1-9][0-9]*)$`))?.[1] ?? null;
}

function validMapping(mapping) {
  if (!record(mapping) || mapping.version !== 1 || !record(mapping.engine)
    || typeof mapping.engine.build !== 'string' || !/^[0-9]{8}\.[0-9]+$/.test(mapping.engine.build)
    || typeof mapping.engine.entryAssetVersion !== 'string' || !/^[0-9]{8}\.[0-9]+(?:\.[0-9]+)?$/.test(mapping.engine.entryAssetVersion)
    || !/^[a-f0-9]{64}$/.test(mapping.engine.manifestSHA256 ?? '')
    || !Array.isArray(mapping.products) || !mapping.products.length
    || !record(mapping.deviceAliases) || !Array.isArray(mapping.bundles) || !mapping.bundles.length) return false;
  const ids = new Set(), handles = new Set(), bundles = new Set();
  for (const row of mapping.products) {
    if (!record(row) || typeof row.productId !== 'string' || !/^[1-9][0-9]*$/.test(row.productId)
      || !slug(row.handle) || !(row.designId === null || slug(row.designId))
      || ids.has(row.productId) || handles.has(row.handle)) return false;
    ids.add(row.productId); handles.add(row.handle);
  }
  for (const [label, device] of Object.entries(mapping.deviceAliases)) {
    if (!label || label !== label.trim() || !(device === null || slug(device))) return false;
  }
  for (const bundle of mapping.bundles) {
    if (typeof bundle !== 'string' || !bundle || bundle !== bundle.trim() || bundles.has(bundle)) return false;
    bundles.add(bundle);
  }
  return true;
}

function optionSchema(options) {
  if (!Array.isArray(options) || options.length !== 2) return null;
  if (!options.every(option => typeof option === 'string') && !options.every(record)) return null;
  const names = [];
  for (let index = 0; index < options.length; index++) {
    const option = options[index];
    if (typeof option === 'string') names.push(option);
    else if (record(option) && typeof option.name === 'string'
      && (!own(option, 'position') || option.position === index + 1)) {
      if (own(option, 'values') && (!Array.isArray(option.values) || !option.values.length
        || option.values.some(value => typeof value !== 'string' || !value || value !== value.trim())
        || new Set(option.values).size !== option.values.length)) return null;
      names.push(option.name);
    }
    else return null;
  }
  return names[0] === 'Size' && names[1] === 'Bundle' ? names : null;
}

function optionValues(variant, schema) {
  const representations = [];
  if (own(variant, 'options')) {
    if (!Array.isArray(variant.options) || variant.options.length !== 2) return null;
    representations.push(variant.options);
  }
  if (['option1', 'option2', 'option3'].some(key => own(variant, key))) {
    if (!own(variant, 'option1') || !own(variant, 'option2')
      || (own(variant, 'option3') && variant.option3 !== null && variant.option3 !== undefined)) return null;
    representations.push([variant.option1, variant.option2]);
  }
  if (own(variant, 'selectedOptions')) {
    if (!Array.isArray(variant.selectedOptions) || variant.selectedOptions.length !== 2) return null;
    const selected = new Map();
    for (const option of variant.selectedOptions) {
      if (!record(option) || !schema.includes(option.name) || selected.has(option.name)) return null;
      selected.set(option.name, option.value);
    }
    representations.push(schema.map(name => selected.get(name)));
  }
  if (!representations.length || representations.some(values => values.some(value => typeof value !== 'string' || !value || value !== value.trim()))) return null;
  const first = representations[0];
  return representations.every(values => values.every((value, index) => value === first[index])) ? first : null;
}

/** Accept Shopify Liquid/.js/.json and normalized Admin/gallery products. */
export function resolveWingmateProductSelection(input = {}) {
  const { product, variantId, mapping } = record(input) ? input : {};
  if (!validMapping(mapping)) return failure('invalid-mapping');
  if (!record(product)) return failure('invalid-product');
  const productId = shopifyId(product.id, 'Product');
  if (!productId || !slug(product.handle)) return failure('invalid-product');
  const reviewed = mapping.products.find(row => row.productId === productId && row.handle === product.handle);
  if (!reviewed) return failure('unreviewed-product');
  const types = ['product_type', 'productType', 'type'].filter(key => own(product, key)).map(key => product[key]);
  if (!types.length || types.some(type => type !== 'Wingmate')) return failure('wrong-family');
  // Normalized gallery payloads omit tags; an exact reviewed pair admits them.
  // When tags are supplied, they must independently confirm the Website role.
  if (own(product, 'tags')) {
    if (!Array.isArray(product.tags) || product.tags.some(tag => typeof tag !== 'string')
      || !product.tags.includes('Role_Website')
      || product.tags.some(tag => /^Role_/i.test(tag) && tag !== 'Role_Website')) return failure('non-website-product');
  }
  const schema = optionSchema(product.options);
  if (!schema) return failure('invalid-options');
  const selectedId = shopifyId(variantId, 'ProductVariant');
  if (!selectedId) return failure('invalid-variant-id');
  const variants = Array.isArray(product.variants) ? product.variants
    : record(product.variants) && Array.isArray(product.variants.nodes) ? product.variants.nodes : null;
  if (!variants || !variants.length) return failure('invalid-variants');
  const ids = new Set(); let selected = null, values = null;
  for (const variant of variants) {
    if (!record(variant)) return failure('invalid-variants');
    const id = shopifyId(variant.id, 'ProductVariant');
    const currentValues = optionValues(variant, schema);
    if (!id || ids.has(id) || !currentValues) return failure('invalid-variants');
    if (currentValues.some((value, index) => record(product.options[index])
      && own(product.options[index], 'values') && !product.options[index].values.includes(value))) return failure('invalid-variants');
    for (const key of ['product_id', 'productId']) {
      if (own(variant, key) && shopifyId(variant[key], 'Product') !== productId) return failure('invalid-variants');
    }
    ids.add(id);
    if (id === selectedId) { selected = variant; values = currentValues; }
  }
  if (!selected) return failure('variant-not-found');
  if (reviewed.designId === null) return failure('unsupported-design');
  const [size, bundle] = values;
  if (!own(mapping.deviceAliases, size) || mapping.deviceAliases[size] === null) return failure('unsupported-device');
  if (!mapping.bundles.includes(bundle)) return failure('unsupported-bundle');
  return {
    eligible: true, productId, variantId: selectedId,
    device: mapping.deviceAliases[size], design: reviewed.designId,
    productTitle: typeof product.title === 'string' && product.title ? product.title : 'Wingmate',
    size, bundle,
  };
}


// Shared source: public/case-simulator/integration/product-selection.js

const activeSelections = new WeakMap();
const fields = ['device', 'design', 'productTitle', 'viewerUrl', 'productId', 'variantId'];
const unavailable = reason => ({ eligible: false, reason });

/**
 * readSelection is synchronous and returns the CURRENT parent and exact variant.
 * mountViewer(button) injects the canonical launcher, returning close/dispose.
 * This adapter owns selection and lifecycle only; it never loads a renderer.
 */
export function mountWingmateProductSelection({ button, readSelection, mapping, viewerURL, mountViewer, eventTarget } = {}) {
  if (!button?.dataset || typeof button.addEventListener !== 'function'
    || typeof readSelection !== 'function' || typeof mountViewer !== 'function') throw new TypeError('A product button, selection reader and viewer launcher are required.');
  if (activeSelections.has(button)) return activeSelections.get(button);
  const owner = eventTarget ?? button;
  if (typeof owner.addEventListener !== 'function' || typeof owner.removeEventListener !== 'function') throw new TypeError('An owning selection event target is required.');
  clear();
  let url;
  try { url = new URL(viewerURL, button.ownerDocument?.baseURI); } catch { throw new TypeError('An exact product viewer URL is required.'); }
  if (!['http:', 'https:'].includes(url.protocol) || url.username || url.password || !url.pathname.endsWith('/product.html')) throw new TypeError('An HTTP product viewer URL is required.');
  let viewer = null, disposed = false, identity = null, current = unavailable('selection-unavailable');

  function clear() {
    button.hidden = true; button.disabled = true; button.setAttribute?.('aria-disabled', 'true');
    for (const field of fields) delete button.dataset[field];
  }
  function refresh() {
    if (disposed) return unavailable('disposed');
    let result;
    try {
      const selection = readSelection();
      result = resolveWingmateProductSelection({ product: selection?.product, variantId: selection?.variantId, mapping });
    } catch { result = unavailable('selection-unavailable'); }
    const nextIdentity = result.eligible ? JSON.stringify([result.productId, result.variantId, result.device, result.design]) : null;
    // A different variant closes the previous modal even when it happens to map
    // to the same physical case. Retry must never outlive its selected product.
    if (identity !== nextIdentity) viewer?.close();
    identity = nextIdentity; current = result;
    if (!result.eligible) { clear(); return { ...result }; }
    button.dataset.device = result.device; button.dataset.design = result.design;
    button.dataset.productTitle = result.productTitle; button.dataset.viewerUrl = url.href;
    button.dataset.productId = result.productId; button.dataset.variantId = result.variantId;
    button.hidden = false; button.disabled = false; button.setAttribute?.('aria-disabled', 'false');
    return { ...result };
  }
  function changed(event) {
    if (event.detail?.formId && owner.id && event.detail.formId !== owner.id) return;
    refresh();
  }
  function beforeOpen(event) {
    // Re-read on the deliberate click as well: a missed theme notification must
    // not open stale variant data. Capture runs before the injected launcher.
    if (!refresh().eligible) { event.preventDefault?.(); event.stopImmediatePropagation?.(); }
  }
  refresh();
  button.addEventListener('click', beforeOpen, true);
  try {
    viewer = mountViewer(button);
    if (typeof viewer?.close !== 'function' || typeof viewer?.dispose !== 'function') throw new TypeError('The viewer launcher must support close and dispose.');
  } catch (error) {
    button.removeEventListener('click', beforeOpen, true);
    viewer?.dispose?.(); clear(); throw error;
  }
  owner.addEventListener('variant:change', changed);
  owner.addEventListener('variant:changed', changed);
  const api = {
    refresh,
    dispose() {
      if (disposed) return;
      disposed = true;
      owner.removeEventListener('variant:change', changed);
      owner.removeEventListener('variant:changed', changed);
      button.removeEventListener('click', beforeOpen, true);
      try { viewer.dispose(); } finally {
        viewer = null; identity = null; clear();
        current = unavailable('disposed'); activeSelections.delete(button);
      }
    },
    get selection() { return { ...current }; },
  };
  activeSelections.set(button, api);
  return api;
}


// Shared source: public/case-simulator/engine/viewer-selection.js
// A selection can start outside an iframe and select the iframe as one node.
// CSS inside that frame cannot clear the parent's persistent selection tint.
// Own only ranges that touch this viewer, and leave editable text selectable.
const editableSelector='input,textarea,[contenteditable]:not([contenteditable="false"]),[role="textbox"]';
const elementOf=node=>node?.nodeType===3?node.parentElement:node;
const editable=node=>!!elementOf(node)?.closest?.(editableSelector);

export function bindWingmateViewerSelection(root,{documentTarget=root?.ownerDocument??globalThis.document}={}){
 if(!root||!documentTarget)return ()=>{};
 let disposed=false;
 function clearOwnedSelection(){
  const selection=documentTarget.getSelection?.();
  if(disposed||!selection||selection.isCollapsed||!selection.rangeCount)return;
  for(let i=0;i<selection.rangeCount;i++){
   const range=selection.getRangeAt(i);
   if(editable(range.commonAncestorContainer))continue;
   let touches=false;
   try{touches=range.intersectsNode(root)}catch{continue}
   if(touches){selection.removeAllRanges();return}
  }
 }
 function preventSelection(event){if(!editable(event.target))event.preventDefault()}
 function pointerEntry(event){if(!editable(event.target))clearOwnedSelection()}
 root.addEventListener('selectstart',preventSelection);
 root.addEventListener('dragstart',preventSelection);
 root.addEventListener('pointerdown',pointerEntry,true);
 documentTarget.addEventListener('selectionchange',clearOwnedSelection);
 clearOwnedSelection();
 return ()=>{
  if(disposed)return;disposed=true;
  root.removeEventListener('selectstart',preventSelection);
  root.removeEventListener('dragstart',preventSelection);
  root.removeEventListener('pointerdown',pointerEntry,true);
  documentTarget.removeEventListener('selectionchange',clearOwnedSelection);
 };
}


// Shared source: public/case-simulator/engine/storefront-viewer.js
// No renderer loads before a deliberate click. Each attempt owns one iframe;
// close, retry and disposal retire that frame and its loading timer together.
const activeLaunchers=new WeakMap();
// Agent START: contain modal scrolling in mobile and embedded browsers.
const productScrollLocks=new WeakMap();
export function lockWingmateProductScroll(doc=globalThis.document,win=globalThis.window){
 let released=false;
 const existing=productScrollLocks.get(doc);
 if(existing){existing.count++;return releaseOnce}
 const x=win.scrollX??0,y=win.scrollY??0,saved=[];
 function own(element,property,value){
  if(!element?.style)return;
  const row={element,property,value,previous:element.style.getPropertyValue(property),priority:element.style.getPropertyPriority(property)};
  saved.push(row);
  element.style.setProperty(property,value);
  row.value=element.style.getPropertyValue(property);
 }
 own(doc.documentElement,'overflow','hidden');own(doc.documentElement,'overscroll-behavior','none');
 const gap=Math.max(0,(win.innerWidth??0)-(doc.documentElement?.clientWidth??win.innerWidth??0));
 if(gap)own(doc.body,'padding-right',((parseFloat(win.getComputedStyle(doc.body).paddingRight)||0)+gap)+'px');
 for(const [property,value]of Object.entries({position:'fixed',top:-y+'px',left:-x+'px',right:'0px',width:'100%',overflow:'hidden'}))own(doc.body,property,value);
 productScrollLocks.set(doc,{count:1,saved,x,y,win});
 function release(){
  const lock=productScrollLocks.get(doc);if(!lock||--lock.count)return;
  productScrollLocks.delete(doc);
  for(const row of lock.saved)if(row.element.style.getPropertyValue(row.property)===row.value){if(row.previous)row.element.style.setProperty(row.property,row.previous,row.priority);else row.element.style.removeProperty(row.property)}
  lock.win.scrollTo?.({left:lock.x,top:lock.y,behavior:'instant'});
 }
 function releaseOnce(){if(released)return;released=true;release()}
 return releaseOnce;
}
// Agent END: modal scroll containment.
export function mountWingmateProductViewer(button){
 if(!button||activeLaunchers.has(button))return activeLaunchers.get(button);
 let dialog=null,frame=null,frameOrigin=null,status=null,statusText=null,retry=null,dismiss=null,slowTimer=null,viewerURL=null,disposed=false,releaseScroll=null,releaseSelection=null;
 function clearLoadingTimer(){if(slowTimer!==null){window.clearTimeout(slowTimer);slowTimer=null}}
 function retireFrame(){clearLoadingTimer();frame?.remove();frame=null;frameOrigin=null}
 function receive(event){
  if(isWingmateCloseRequest(event,frame,frameOrigin)){close();return}
  if(isWingmateProductMessage(event,frame,frameOrigin,'ready')){
   clearLoadingTimer();dialog.dataset.state='ready';frame.setAttribute('aria-busy','false');
   if(status.contains(document.activeElement))dismiss.focus({preventScroll:true});
   status.hidden=true;frame.hidden=false;
  }else if(isWingmateProductMessage(event,frame,frameOrigin,'error'))fail();
 }
 function close(){
  if(!dialog)return;
  window.removeEventListener('message',receive);retireFrame();
  releaseSelection?.();releaseSelection=null;
  const previous=dialog;dialog=null;previous.close?.();previous.remove();
  releaseScroll?.();releaseScroll=null;
  status=statusText=retry=dismiss=viewerURL=null;button.focus({preventScroll:true});
 }
 function fail(){
  if(!dialog)return;retireFrame();dialog.dataset.state='error';
  status.hidden=false;statusText.textContent='Your 3D view couldn’t load. Try again.';retry.hidden=false;
 }
 function load(){
  if(!dialog||disposed)return;retireFrame();dialog.dataset.state='loading';
  status.hidden=false;statusText.textContent='Loading your Wingmate…';retry.hidden=true;
  frame=document.createElement('iframe');frame.title='Interactive Wingmate 3D view';frame.referrerPolicy='strict-origin-when-cross-origin';frame.allow='fullscreen';frame.draggable=false;frame.hidden=true;frame.setAttribute('aria-busy','true');
  const current=frame;frame.addEventListener('error',()=>{if(frame===current)fail()});dialog.append(frame);
  frameOrigin=viewerURL.origin;frame.src=viewerURL.href;
  slowTimer=window.setTimeout(()=>{
   slowTimer=null;if(!dialog||frame!==current)return;
   dialog.dataset.state='slow';statusText.textContent='Taking a little longer. You can keep waiting or try again.';retry.hidden=false;
  },30000);
 }
 function open(){
  if(disposed||dialog)return;
  const {device,design,viewerUrl}=button.dataset;
  if(!device||!/^[-a-z0-9]{1,100}$/.test(device)||!design||!/^[-a-z0-9]{1,100}$/.test(design))return;
  let url;try{url=new URL(viewerUrl??'product.html',document.baseURI)}catch{return}
  if(!['http:','https:'].includes(url.protocol)||!url.pathname.endsWith('/product.html'))return;
  url.searchParams.set('viewer','product');url.searchParams.set('device',device);url.searchParams.set('design',design);url.searchParams.set('contents','cards');
  url.searchParams.set('parentOrigin',location.origin);url.searchParams.set('embed','true');viewerURL=url;
  dialog=document.createElement('dialog');dialog.className='wingmate-product-dialog';dialog.setAttribute('aria-label','Wingmate 3D view');
  const header=document.createElement('header'),heading=document.createElement('h2');dismiss=document.createElement('button');
  heading.textContent=button.dataset.productTitle??'Wingmate in 3D';dismiss.type='button';dismiss.textContent='Close';dismiss.setAttribute('aria-label','Close 3D view');dismiss.onclick=close;
  header.append(heading,dismiss);
  status=document.createElement('div');status.className='wingmate-product-status';status.setAttribute('role','status');status.setAttribute('aria-live','polite');
  const indicator=document.createElement('span');indicator.className='wingmate-product-loading';indicator.setAttribute('aria-hidden','true');
  statusText=document.createElement('p');retry=document.createElement('button');retry.type='button';retry.textContent='Try again';retry.hidden=true;
  retry.onclick=()=>{load();dismiss?.focus({preventScroll:true})};status.append(indicator,statusText,retry);
  dialog.append(header,status);document.body.append(dialog);
  releaseSelection=bindWingmateViewerSelection(dialog);
  dialog.addEventListener('cancel',event=>{event.preventDefault();close()});
  dialog.addEventListener('click',event=>{if(event.target!==dialog)return;const bounds=dialog.getBoundingClientRect();if(event.clientX<bounds.left||event.clientX>bounds.right||event.clientY<bounds.top||event.clientY>bounds.bottom)close()});
  const ownedDialog=dialog;dialog.addEventListener('close',()=>{if(dialog===ownedDialog)close()},{once:true});
  releaseScroll=lockWingmateProductScroll();
  if(dialog.showModal)dialog.showModal();else dialog.setAttribute('open','');
  window.addEventListener('message',receive);load();dismiss.focus({preventScroll:true});
 }
 button.addEventListener('click',open);
 const api={open,close,dispose(){if(disposed)return;disposed=true;close();button.removeEventListener('click',open);activeLaunchers.delete(button)}};
 activeLaunchers.set(button,api);return api;
}
export function mountWingmateProductViewers(container=document){return [...container.querySelectorAll('[data-wingmate-viewer]')].map(mountWingmateProductViewer)}
mountWingmateProductViewers();

/* Agent END Codex: Generated shared adapter modules. */
